const list = {
  path: 'mesManagement',
  component: resolve => require(['@/pages/admin/platform/message/mesManagement'], resolve)
}

export default list
